export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  return {
    provide: {
      http: <T>(pathname: string) => {
        return $fetch<T>(`${config.public.baseApiUrl}${pathname}`, {
          headers: visitorIpHeaders(nuxtApp)
        })
      }
    }
  }
})
